<div class="commissions-container">
  <div class="filters">
    <div class="search-filter-group">
      <!-- Search Box -->
      <div class="standard-input has-icon search-box">
        <div class="input-container">
          <input type="text"
              placeholder="{{ 'commission.listing.search' | translate }}"
              [formControl]="searchInput"
              (input)="search($event)"
              />
          <span class="btn-icon" style="cursor: default;">
            <app-svg-icon svgIcon="search_icon"></app-svg-icon>
          </span>
        </div>
      </div>

      <!-- Filter Button -->
      <!-- TODO: Uncomment when filter is implemented -->
      <!-- <div class="filter-button-group">
        <button class="action-button" style="cursor: not-allowed">
          <div class="action-button-icon">
            <img src="assets/icones/filter_icon.svg" alt="" />
          </div>
          <span class="action-button-text">{{
            "common.filter" | translate
          }}</span>
        </button>
      </div> -->

      <!-- Delete Button -->
      <button
        *ngIf="selectedCommissions.length"
        class="action-btn secondary-btn icon-btn"
        style="border-color: #970000; color: #970000;"
        (click)="deleteConfirmation()"
      >
        <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
      </button>


      <!-- New Agent Button -->
      <button
        style="margin-left: auto"
        class="action-btn primary-btn"
        (click)="newProfile()"
      >
        <span class="icon">
          <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
        </span>
        <span> {{ 'commission.actions.create_profile' | translate }} </span>
      </button>
    </div>
  </div>
  <div class="commissions-content">
    <table class="commissions-table">
      <thead>
        <tr
          class="row header"
          style="padding-top: 10px; border: unset; height: unset"
        >
          <th>
            <mat-checkbox
              [checked]="isAllAgentsSelected()"
              [indeterminate]="isPartialSelectedAll()"
              (change)="toggleAllAgents($event.checked)"
            >
            </mat-checkbox>
            <div
              class="sortable-column"
            >
            {{ 'commission.labels.profile' | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="
                    activeSortMode == 'asc' && activeSortKey == 'name'
                  "
                  (click)="sortByKey('name', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="
                    activeSortMode == 'desc' && activeSortKey == 'name'
                  "
                  (click)="sortByKey('name', 'desc')"
                ></span>
              </div>
            </div>
          </th>
          <th class="sortable-column">
            {{ 'commission.labels.type' | translate }}
            <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="
                    activeSortMode == 'asc' && activeSortKey == 'type'
                  "
                  (click)="sortByKey('type', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="
                    activeSortMode == 'desc' && activeSortKey == 'type'
                  "
                  (click)="sortByKey('type', 'desc')"
                ></span>
              </div>
          </th>
          <th class="sortable-column">
            {{ 'commission.labels.agents' | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'agents'
                "
                (click)="sortByKey('agents', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'agents'
                "
                (click)="sortByKey('agents', 'desc')"
              ></span>
            </div>
          </th>
          <th class="sortable-column">
            {{ 'commission.labels.created_at' | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'create_at'
                "
                (click)="sortByKey('create_at', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'create_at'
                "
                (click)="sortByKey('create_at', 'desc')"
              ></span>
            </div>
          </th>
          <th class="sortable-column">
            {{ 'commission.labels.expiry_date' | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'expiry_date'
                "
                (click)="sortByKey('expiry_date', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'expiry_date'
                "
                (click)="sortByKey('expiry_date', 'desc')"
              ></span>
            </div>
          </th>
          <th>
            {{ 'commission.labels.description' | translate }}
          </th>
          <th class="sortable-column">
            {{ 'commission.labels.status' | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'status'
                "
                (click)="sortByKey('status', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'status'
                "
                (click)="sortByKey('status', 'desc')"
              ></span>
            </div>
          </th>
        </tr>
        <tr class="row header" style="padding-bottom: 10px; height: unset">
          <th></th>
          <th></th>
          <th>
            <span style="font-weight: 400" class="secondary-text">
              {{ 'commission.labels.assigned' | translate }}
            </span>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <cdk-virtual-scroll-viewport itemSize="50" class="commissions-viewport">
          <ng-container
            *cdkVirtualFor="
              let commission of filteredCommissions;
              trackBy: trackByAgentId
            "
          >
            <tr class="row" (click)="goToDetails(commission)">
              <td>
                <mat-checkbox
                  [disableRipple]="true"
                  [checked]="selectedCommissions.includes(commission.id!)"
                  (change)="toggleAgent(commission.id!, $event.checked)"
                  (click)="$event.stopPropagation()"
                ></mat-checkbox>
                <span
                  class="truncate"
                  style="width: 200px"
                  [title]="commission.name"
                >
                  {{ commission.name | titleCase }}
                </span>
              </td>
              <td>
                <span class="tag" [class]="commission.type === 'base' ? 'neutral' : 'warning'">{{ 'commission.type.' + commission.type | translate }}</span>
              </td>
              <td>
                {{ commission.agents }}
              </td>
              <td>
                {{ commission.create_at | date: DATE_FORMAT }}
              </td>
              <td>
                {{ commission.expiry_date ? (commission.expiry_date | date: DATE_FORMAT) : '--' }}
              </td>
              <td>
                <span>{{ commission.commission || 0 }}% {{ getCalculationType(commission) }}</span>
                <div class="secondary-text">
                  {{ getDescription(commission) | titleCase }}
                </div>
              </td>
              <td>
                <span class="tag" [class]="commission.status === 'active' ? 'positive' : 'negative'">{{ 'commission.status.' + commission.status | translate }}</span>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!commissions.length">
            <div
              style="
                height: 200px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              class="secondary-text"
            >
              {{ 'commission.listing.no_data' | translate }}
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
